import { useParams, Link, Navigate } from "react-router-dom";
import { EDUCATION_TOPICS } from "@/lib/content";
import { ArrowLeft, ChevronRight } from "lucide-react";
import ResponsibleBanner from "@/components/ResponsibleBanner";

export default function EducationDetail() {
  const { slug } = useParams();
  const idx = EDUCATION_TOPICS.findIndex((t) => t.slug === slug);
  if (idx === -1) return <Navigate to="/education" replace />;
  const topic = EDUCATION_TOPICS[idx];
  const next = EDUCATION_TOPICS[(idx + 1) % EDUCATION_TOPICS.length];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Link to="/education" className="inline-flex items-center gap-1 text-sm font-bold text-smasher-gold hover:text-smasher-orange mb-6"><ArrowLeft className="w-4 h-4" /> ALL TOPICS</Link>
      <div className="text-xs font-bold tracking-[0.2em] text-smasher-orange mb-2">BETTING EDUCATION</div>
      <h1 className="font-heading font-black uppercase text-4xl sm:text-5xl text-white mb-4">{topic.title}</h1>
      <p className="text-lg text-slate-300 leading-relaxed">{topic.body}</p>

      <div className="panel p-5 mt-8 border-smasher-gold/25">
        <p className="text-sm text-slate-400"><span className="font-bold text-smasher-gold">Remember:</span> Sportsbook Smasher is about understanding the game before you make the wager. No lesson guarantees a win — betting always involves risk.</p>
      </div>

      <Link to={`/education/${next.slug}`} className="panel panel-hover p-5 mt-6 flex items-center justify-between group" data-testid="edu-next">
        <div>
          <div className="text-xs text-slate-500">NEXT LESSON</div>
          <div className="font-heading font-bold text-lg text-white group-hover:text-smasher-gold">{next.title}</div>
        </div>
        <ChevronRight className="w-6 h-6 text-smasher-gold" />
      </Link>

      <div className="mt-8"><ResponsibleBanner compact /></div>
    </div>
  );
}
